<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="dash-trucks-top1" *ngIf="DeleteAction">
      <span class="mt-4">Selected: {{ SelectedItems }}</span>
    </div>
    <div class="dash-trucks-top2">
      <button
        *ngIf="addBtn"
        type="button"
        class="button buttonBlue fixed-btn"
        (click)="action('New', null)"
      >
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="selectAction"
        (click)="Selected()"
      >
        <img
          class="trucks-head-img"
          src="../../../assets/img/check-circle.svg"
        />

        Select
      </button>

      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="cancelAction"
        (click)="onCancel()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="button delete-btn fixed-btn m-rl"
        *ngIf="deleteAction"
        (click)="onDeleteType()"
      >
        <img class="trucks-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          class="search pl-2"
          placeholder="Truck Type"
          id="truckCatgNumber"
          #newItem
          style="text-transform: capitalize"
          (keyup)="onInputChange(newItem.value)"
          (keyup.enter)="isInputValid && search(newItem.value)"
        />
        <button
          [disabled]="!isInputValid"
          class="search_number"
          *ngIf="search_btn"
          (click)="search(newItem.value)"
        >
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button
          *ngIf="clear_Btn"
          class="search_number1"
          (click)="resetSearch()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="trucks">
    <div [class.spinner]="loading"></div>

    <div class="row to_container" *ngIf="!truckTypeList?.length && !loading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="row">
      <div class="col-md-3" *ngFor="let item of truckTypeList; let i = index">
        <div class="truckscol">
          <div class="trucks-head">
            <mat-checkbox
              *ngIf="DeleteAction"
              (change)="matItem($event, item._id, i)"
            ></mat-checkbox>
            <img
              src="../../../assets/img/edit icon.png"
              class="editimg"
              (click)="action('Edit', item)"
            />
          </div>

          <img src="{{ item.truck_type_image }}" class="truckImg" />
          <div class="trucks-body">
            <p class="truck-number">Truck Type: {{ item.truck_weight }}</p>
            <p class="truck-date">
              Truck Category: {{ item.truckCategory[0]?.truck_category_name }}
            </p>
            <p class="truck-insu">
              Description: {{ item.truck_type_description }}
            </p>
            <p class="truck-insu">Truck Feet: {{ item.truck_feet }}</p>
            <p class="truck-insu">Wheels: {{ item.minimum_amount ? item.minimum_amount + ' W' : '-' }}</p>
            <p class="truck-insu">
              Speed Limit: {{ item.spped_limit ? item.spped_limit : "-" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="last_page && last_page > 1" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
    <button
      class="btn"
      [disabled]="fetch_page == 1"
      (click)="pagination('first')"
    >
      <img
        src="../../../assets/img/pagination-left.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('last')"
    >
      <img
        src="../../../assets/img/pagination-right.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('1')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap=" round"
          stroke-linejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>
</div>
